import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

export type DrawerType =
  | 'rti-request'
  | 'septic-tank-cleaning'
  | 'bulk-garbage-collection'
  | 'street-vendor-registration'
  | 'complaint-status'
  | 'e-file-management'
  | 'complaint-category'
  | 'chat-drawer'
  | 'ai-chat-drawer'
  | null;

interface DrawerContextType {
  openDrawer: (type: DrawerType) => void;
  closeDrawer: () => void;
  currentDrawer: DrawerType;
  isDrawerOpen: boolean;
}

const DrawerContext = createContext<DrawerContextType | undefined>(undefined);

export const useDrawer = () => {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within DrawerProvider');
  }
  return context;
};

interface DrawerProviderProps {
  children: ReactNode;
}

export const DrawerProvider = ({ children }: DrawerProviderProps) => {
  const [currentDrawer, setCurrentDrawer] = useState<DrawerType>(null);

  const openDrawer = (type: DrawerType) => {
    setCurrentDrawer(type);
  };

  const closeDrawer = () => {
    setCurrentDrawer(null);
  };

  return (
    <DrawerContext.Provider
      value={{
        openDrawer,
        closeDrawer,
        currentDrawer,
        isDrawerOpen: currentDrawer !== null,
      }}
    >
      {children}
    </DrawerContext.Provider>
  );
};

